import { useState, useEffect, useRef } from "react";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";

const Npi = ({ userEdit }) => {
  const { userToken, SetSharedObject } = useUserStore((state) => ({
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
  }));
  const [npiResult, SetNpiResult] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [notExists, SetNotExists] = useState(false);
  const [answers, setAnswers] = useState({ NPI: "" });
  const searchBtnRef = useRef(null);
  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("npiResultModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const SearchNpi = async () => {
    if (answers.NPI === "") {
      SetNotExists(false);
      return;
    }
    SetProcessing(true);
    SetNotExists(false);
    let call =
      "/organization/SearchNPI?searchNPI=" + answers.NPI + "&npiType=2";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      if (dt && Object.keys(dt).length > 0 && dt.constructor === Object) {
        let o = {
          NPI: dt.npi,
          Name: dt.providerOrganizationName,
          Addresses: {
            FirstLine: dt.providerFirstLineBusinessMailingAddress,
            SecondLine: "",
            City: dt.providerBusinessMailingAddressCityName,
            State: dt.providerBusinessMailingAddressStateCode,
            County: "",
            PostalCode: dt.providerBusinessMailingAddressPostalCode,
            Country: dt.providerBusinessMailingAddressCountryCode,
            Phone: dt.providerBusinessPracticeLocationAddressTelephoneNumber,
            PhoneExt: "",
            Fax: dt.providerBusinessPracticeLocationAddressFaxNumber,
            FaxExt: "",
            IsCertAddress: false,
            AddressType: 0,
            IsValid: false,
          },
        };
        SetNpiResult(o);
        $("#npiResultModal").modal("show");
      } else {
        SetNotExists(true);
      }
    } else if (res.status === "SERVERERROR") {
      SetNotExists(true);
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const SelectNpi = () => {
    userEdit(npiResult);
    CloseModal();
  };
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
    }

    const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        $('#npiResultModal').modal('hide');
        searchBtnRef.current?.focus();
    };
  return (
    <div className="Npi">
      <div className="field-wrapper npi-container ">
        <label htmlFor="npi" className="spacer-margin5 blk-clr">
          NPI:
        </label>
        <input
          className="form-control w-md6 spacer-inline"
          name="npi"
          id="npi"
          type="search"
          placeholder="Optional"
          autoComplete="off"
          aria-describedby="npiSearch"
          onChange={(el) => {
            if (el.target.value === "") SetNotExists(false);
            setAnswer("NPI", el.target.value);
          }}
        />
        <span id="npiSearch" className="sr-only">Enter the NPI number then click Search to look up organization information.</span>
        <button
          ref={searchBtnRef}
          type="button"
          className="btn btn-primary spacer-margin2"
          data-toggle="modal"
          disabled={processing}
          aria-disabled={processing}
          aria-busy={processing}
          onClick={(el) => {
            SearchNpi();
            el.preventDefault();
          }}
        >
          {processing ? "Searching..." : "Search"}
        </button>

        {notExists ? (
          <div 
            className="alert alert-danger" 
            role="alert" 
            aria-live="assertive" 
            aria-atomic="true">
            We could not connect or find NPI {answers.NPI} you entered. Please
            double check your number and try again.
          </div>
        ) : null}
      </div>
      <div
        className="modal fade"
        id="npiResultModal"
        tabIndex="-1"
        role="dialog"
        data-backdrop="static"
        aria-describedby="npiResultDesc"
        aria-labelledby="npiResultTitle"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="npiResultTitle">
                NPI Lookup
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close Close NPI lookup result"
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-form">
                <p className="descript-container">Here is what we found.</p>
                <dl className="field-wrapper" id="npiResultDesc">
                  <dt>NPI ID:</dt> 
                  <dd>{npiResult.NPI}</dd><br />
                  <dt>Name:</dt> 
                  <dd>{npiResult.Name}</dd><br />
                  <dt>Address:</dt><br />
                  <dd className="sp-margin5">{npiResult.Addresses?.FirstLine},</dd>
                  <dd className="sp-margin5">{npiResult.Addresses?.City}, </dd>
                  <dd className="sp-margin5">{npiResult.Addresses?.State}</dd>
                  <dd className="sp-margin5">{npiResult.Addresses?.PostalCode}</dd><br />

                  <dt>Phone:</dt>
                  <dd>{formatPhoneNumber(npiResult.Addresses?.Phone)}</dd><br />
                  <dt>Fax:</dt>
                  <dd>{formatPhoneNumber(npiResult.Addresses?.Fax)}</dd>
                </dl>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                aria-label={`Select NPI ${npiResult.NPI} � ${npiResult.Name}`}
                onClick={SelectNpi}
              >
                Select
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Npi;
